import { Link } from "react-router-dom";
import { ArrowBigRight } from "lucide-react";
import { ProductCategoryData } from "../types/productCategories";
import Button from "../../../common/components/Button";

export class ProductCategoryTransformer {
  static tableTransformer(operationKlassToCheckPermission?: string) {
    return (categories: ProductCategoryData[]) => {
      return categories.map((category) => ({
        ...category,
        actions: <Link to={`/product-categories/${category.id}`} className="cursor-pointer">
          <Button name="access_product_categories_list" className="bg-transparent hover:bg-transparent p-0" operationKlassToCheckPermission={operationKlassToCheckPermission}>
            <ArrowBigRight />
          </Button>
        </Link>
      }));
    };
  }

  static quickSearchModelTransformer() {
    return (categories: ProductCategoryData[]) => {
      return categories.map((category) => ({
        route: `/product-categories/${category.id}`,
        items: [
          ['Nome', category.display_name],
          ['Produtos cadastrados', category.products_count || 0],
        ]
      }));
    };
  }
}
